import { render } from "./adminEvents.vue?vue&type=template&id=27a2a90e"
import script from "./adminEvents.vue?vue&type=script&lang=js"
export * from "./adminEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__